<template>
  <div ref="loaderContainer" class="loader">
    <canvas
      ref="loader"
      class="loaderCanvas"
      :style="{ display: `${showLoader ? 'block' : 'none'}` }"
    >
    </canvas>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'loader',
  props: {
    width: { type: Number, default: undefined },
    height: { type: Number, default: undefined },
    spriteWidth: { type: Number, default: undefined },
    spriteHeight: { type: Number, default: undefined },
    spriteUrl: { type: String, default: undefined },
    ticksPerFrame: { type: Number, default: undefined },
    numberOfFrames: { type: Number, default: undefined },
  },

  data() {
    return {
      showLoader: true,
      loaderContainer: null,
    };
  },

  computed: mapState('filterList', {
    showOverlay: (state) => state.loading,
  }),

  watch: {
    showOverlay() {
      /* istanbul ignore next */
      if (this.showOverlay === true) {
        window.addEventListener('mousemove', this.followMouse);
      } else {
        window.removeEventListener('mousemove', this.followMouse);
        this.$refs.loaderContainer.style.left = null;
        this.$refs.loaderContainer.style.top = null;
      }
    },
  },

  mounted() {
    this.canvas = this.$refs.loader;
    this.canvas.width = this.width;
    this.canvas.height = this.height;

    this.loaderImage = new Image();

    this.loader = this.sprite({
      context: this.canvas.getContext('2d'),
      width: 23,
      height: 3450,
      image: this.loaderImage,
      numberOfFrames: 150,
      ticksPerFrame: 1,
    });

    this.loaderImage.addEventListener('load', this.loop);
    this.loaderImage.src = this.spriteUrl;
  },

  methods: {
    loop() {
      window.requestAnimationFrame(this.loop);
      this.loader.update();
      this.loader.render();
    },

    sprite(options) {
      const that = {};
      let frameIndex = 0;
      let tickCount = 0;
      const ticksPerFrame = options.ticksPerFrame || 0;
      const numberOfFrames = options.numberOfFrames || 1;

      that.context = options.context;
      that.width = options.width;
      that.height = options.height;
      that.image = options.image;

      /* istanbul ignore next */
      that.update = function () {
        tickCount += 1;

        /* istanbul ignore next */
        if (tickCount > ticksPerFrame) {
          tickCount = 0;

          if (frameIndex < numberOfFrames - 1) {
            frameIndex += 1;
          } else {
            frameIndex = 0;
          }
        }
      };

      /* istanbul ignore next */
      that.render = function () {
        that.context.clearRect(0, 0, that.width, that.height);
        that.context.drawImage(
          that.image,
          0,
          (frameIndex * that.height) / numberOfFrames,
          that.width,
          that.height / numberOfFrames,
          0,
          0,
          that.width,
          that.height / numberOfFrames
        );
      };

      return that;
    },
    followMouse(e) {
      this.$refs.loaderContainer.style.display = 'block';
      this.$refs.loaderContainer.style.left = `${window.pageXOffset + e.clientX + 7}px`;
      this.$refs.loaderContainer.style.top = `${window.pageYOffset + e.clientY + 7}px`;
    },
  },
};
</script>
